<template>
  <div class="coupon-container">
    <h2 class="mb-3">เงื่อนไขการใช้คูปอง</h2>
    <v-card class="pa-4 elevation-5 rounded-xl">
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="couponList"
        :server-items-length="coupons && coupons.total"
        :footer-props="{
          itemsPerPageOptions,
        }"
        :options.sync="options"
        no-data-text="ไม่พบข้อมูล"
        no-results-text="ไม่พบข้อมูล"
      >
        <template v-slot:top>
          <v-toolbar flat color="white" :height="checkScreen">
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12" md="8">
                    <v-text-field
                      :disabled="isLoading"
                      v-model="keyword"
                      label="ค้นหาจาก"
                      single-line
                      outlined
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn
                      outlined
                      depressed
                      @click="searchKeyword"
                      color="#009b3f"
                      :block="checkMdScreen"
                      >ค้นหา</v-btn
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex justify-end">
                  <v-btn
                    color="success"
                    class="mb-2"
                    :block="checkMdScreen"
                    @click="createForm"
                    >+ เพิ่มคูปอง</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ $generateDate(item.createdAt) }}
        </template>
        <template v-slot:item.status="{ item }">
          <div v-if="item.status === 'active'" class="success--text">
            ใช้งาน
          </div>
          <div v-else class="red--text">หยุดการใช้งาน</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn depressed text color="success" @click="selectItem(item.id)"
            ><b>ดูข้อมูล</b></v-btn
          >
          <v-btn depressed text color="error" @click="deleteItem(item)"
            ><b>ลบ</b></v-btn
          >
        </template>
      </v-data-table>
    </v-card>
    <Confirm v-model="conf.status" :data="conf" @confirm="deleteData" />
    <CouponForm
      :modal="dialog"
      :clearData="resetForm"
      :create="create"
      @submit="submit"
      :editId="editId"
    />
  </div>
</template>

<script>
import { get, reduce } from "lodash";
import Utils from "@/mixin";

import { itemsPerPageOptions } from "@/plugins/common";
import Confirm from "@/components/Confirm";

import CouponForm from "./Coupon/Form";

export default {
  name: "Admin-Coupon",
  mixins: [Utils],
  components: {
    CouponForm,
    Confirm,
  },
  computed: {
    couponList() {
      const { coupons } = this;
      return coupons.data;
    },
    checkScreen() {
      const { windowWidth } = this;
      if (windowWidth >= 1440) {
        return "64px";
      } else if (windowWidth < 1440 && windowWidth >= 960) {
        return "64px";
      } else if (windowWidth < 960) {
        return "180px";
      }
      return "0px";
    },
    checkMdScreen() {
      const { windowWidth } = this;
      if (windowWidth >= 960) {
        return false;
      } else {
        return true;
      }
    },
  },
  data: () => ({
    editId: "",
    dialog: false,
    create: false,
    keyword: "",
    total: 0,
    options: {
      itemsPerPage: 50,
    },
    itemsPerPageOptions: [],
    headers: [
      { text: "วันที่สร้างคูปอง", value: "createdAt", sortable: false },
      { text: "ชื่อคูปอง", value: "name", sortable: false },
      { text: "Privilege ID*", value: "privilegeId", sortable: false },
      { text: "สถานะคูปอง", value: "status", sortable: false },
      {
        text: "ดำเนินการ",
        value: "actions",
        align: "center",
        sortable: false,
        width: "200px",
      },
    ],
    conf: {
      status: false,
      title: "ยืนยันการลบข้อมูล?",
      text: `คูปอง`,
      cancelText: `ยกเลิก`,
      confirmText: `ยืนยัน`,
    },
    windowWidth: window.innerWidth,
  }),
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
    this.itemsPerPageOptions = itemsPerPageOptions;
  },
  methods: {
    async getInitialData() {
      let condition = {};

      // filter
      if (this.keyword) {
        condition.query = this.keyword;
      }

      // paging
      {
        // Per page
        if (this.options && this.options.itemsPerPage) {
          condition.limit = this.options.itemsPerPage;
        }

        // Page
        if (this.options && this.options.page) {
          condition.page = this.options.page;
        }
      }

      // sort
      if (this.options?.sortBy?.[0]) {
        condition.order = `${this.options.sortBy[0]}:${
          this.options?.sortDesc?.[0] ? "desc" : "asc"
        }`;
      }

      this.getCoupons(condition);
    },
    selectItem(id) {
      this.editId = id;
      this.toggleForm();
    },
    searchKeyword() {
      this.getInitialData();
    },
    toggleForm() {
      this.dialog = !this.dialog;
    },
    resetForm() {
      this.dialog = false;
      this.create = false;
      this.setInitialDialog();
    },
    createForm() {
      this.dialog = !this.dialog;
      this.create = !this.create;
    },
    setInitialDialog() {
      this.editId = "";
    },
    async submit(data = {}) {
      const premiums = reduce(
        data.premiums,
        (o, e) => {
          o.push({
            ...e,
            unit: e.unit === "จำนวน" ? "amount" : "qty",
            volume: parseFloat(e.volume),
          });
          return o;
        },
        []
      );
      const conditions = reduce(
        data.conditions,
        (o, e) => {
          o.push({
            ...e,
            volume: parseFloat(e.volume),
          });
          return o;
        },
        []
      );
      const submitForm = {
        name: get(data, "name", ""),
        privilegeId: get(data, "privilegeId", ""),
        status: get(data, "status", ""),
        conditions,
        premiums,
      };
      if (this.editId !== "") {
        submitForm.id = this.editId;
        await this.editCoupon(submitForm);
      } else {
        await this.createCoupon(submitForm);
      }
      this.editId = "";
      this.getInitialData();
    },
    deleteItem(data = {}) {
      this.conf = {
        ...this.conf,
        text: `คูปอง ${data?.name}`,
        status: true,
        data,
      };
    },
    async deleteData(value = false) {
      if (value) {
        await this.deleteCoupon({ id: this.conf?.data?.id });
      }
      this.conf = {
        ...this.conf,
        status: false,
        data: undefined,
      };
    },
  },
  watch: {
    options: {
      handler() {
        this.getInitialData();
      },
      deep: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
}
</style>